import { Card, Divider, Grid, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import FormButtonOptions from '../../../FormFields/FormButtonOptions';
import FormTitle from '../../../FormFields/FormTitle';
import { CLINICAL } from '../../../formQuestionsEnum';
import { formCardStyle } from '../../../TransitionStyles';

AssociatedOrganizations.propTypes = {
  permissions: PropTypes.object,
};

export default function AssociatedOrganizations({ permissions }) {
  const showForm = [CLINICAL.IS_JCAHO_CERTIFIED, CLINICAL.WORKS_WITH_PA_QIO].some(({ id }) => id in permissions);

  return (
    showForm && (
      <Card sx={formCardStyle}>
        <Typography sx={{ mb: 1 }} align="center" variant="body1" color="info.main">
          Associated Organizations
        </Typography>
        <Divider sx={{ mb: 1, mt: 2, borderWidth: 1 }} />
        <Grid container spacing={1.5}>
          {CLINICAL.IS_JCAHO_CERTIFIED.id in permissions && (
            <Grid item xs={12}>
              <FormTitle fieldAttributes={{ questionTitle: 'Is the facility JCAHO certified?' }} />
              <FormButtonOptions
                fieldName={CLINICAL.IS_JCAHO_CERTIFIED.fieldName}
                fieldAttributes={{
                  isEditable: permissions[CLINICAL.IS_JCAHO_CERTIFIED.id],
                  options: [
                    { label: 'Yes', value: true },
                    { label: 'No', value: false },
                  ],
                }}
              />
            </Grid>
          )}
          {CLINICAL.WORKS_WITH_PA_QIO.id in permissions && (
            <Grid item xs={12}>
              <FormTitle fieldAttributes={{ questionTitle: 'Does the facility work with PA QIO?' }} />
              <FormButtonOptions
                fieldName={CLINICAL.WORKS_WITH_PA_QIO.fieldName}
                fieldAttributes={{
                  isEditable: permissions[CLINICAL.WORKS_WITH_PA_QIO.id],
                  options: [
                    { label: 'Yes', value: true },
                    { label: 'No', value: false },
                  ],
                }}
              />
            </Grid>
          )}
        </Grid>
      </Card>
    )
  );
}
